import { useCallback, useState } from "react";

export type EmbryoSexDisclosure = {
  /** True while she keeps the embryo's sex a surprise and has not asked to see it. */
  hidden: boolean;
  /** Show the sex everywhere in this view: facts, lab notation and chart. */
  reveal: () => void;
};

/**
 * The one switch for showing an embryo's sex. Every place that shows it (the
 * embryo sheet's overview and genetics, the cryo vault specimen dialog) reads
 * this, so a single "Show" reveals all of them in that view. Pass the embryo
 * a view is showing, so moving to another embryo starts hidden again.
 *
 * The sex shows by default. Keeping it a surprise is a patient preference the
 * backend does not store yet.
 */
export function useEmbryoSexDisclosure(
  embryoId?: string | null,
): EmbryoSexDisclosure {
  // TODO(louise-life/dashboard-api#1983): read the patient's embryoSexDisclosure preference
  const keepSexASurprise = false;
  const subject = embryoId ?? "";
  const [revealedSubject, setRevealedSubject] = useState<string | null>(null);
  const reveal = useCallback(() => setRevealedSubject(subject), [subject]);

  return {
    hidden: keepSexASurprise && revealedSubject !== subject,
    reveal,
  };
}
